// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"yj","centerLink":"zj","productSection":"Aj","item":"Bj","ctaButton":"Cj"};